// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionHeader_wrapper__Khshi","left":"SectionHeader_left__EHAzx","title":"SectionHeader_title__xQXGi","right":"SectionHeader_right__iuxg2"};